// Configurazione Production
export const productionConfig = {
  ENV: 'production',
  API_URL: 'https://musea.puradigital.it/human',
  API_URL_V1: 'https://musea.puradigital.it/be',
  DEBUG: false,
  TIMEOUT: 30000,
}; 